export default {
      id: "arrowdown2-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrowdown2",
      toString: function () {
        return this.url;
      }
    }